import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import ListSubheader from '@material-ui/core/ListSubheader';
import Collapse from '@material-ui/core/Collapse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '0.9rem',
    color: theme.palette.grey[800],
    backgroundColor: '#fff',
    cursor: 'pointer'
  },
  text: {
    flex: '1 1 auto',
    userSelect: 'none'
  },
  icon: {
    fontSize: '1.3rem',
    color: theme.palette.grey[700],
    transition: 'transform 0.3s ease',
    transform: 'rotate(-90deg)',
    '&.open': {
      transform: 'rotate(0)'
    }
  }
}));

const NavigationHeader = ({
  text,
  onClick = () => {},
  open,
  children,
  visible = () => true
}) => {
  const classes = useStyles();

  if (!visible()) {
    return null;
  }

  function renderExpandIcon() {
    if (!children || children.length === 0) {
      return null;
    }
    const iconClasses = { root: classes.icon };
    return (
      <ExpandMoreIcon className={open ? 'open' : ''} classes={iconClasses} />
    );
  }

  return (
    <>
      <ListSubheader className={classes.root} onClick={onClick}>
        <span className={classes.text}>{text}</span>
        {renderExpandIcon()}
      </ListSubheader>
      <Collapse in={open} unmountOnExit>
        {children}
      </Collapse>
    </>
  );
};

NavigationHeader.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  open: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export default NavigationHeader;
